import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDatepicker]'
})
export class DatepickerDirective {

  constructor(
    private model: NgControl,
    private el: ElementRef
  ) { }

  @HostListener('ngModelChange') ngModelChange() {
    this.modelValue();
  }

  private modelValue() {
    var scope: any = this.model;
    var elementId: string = this.el.nativeElement.id;

    $("#" + elementId).datepicker({
      onSelect: function(dateText: any) {
        scope.valueAccessor.onChange(dateText);
      }
    });
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/datepicker.directive.ts
 **/